import { Component, OnInit, HostBinding, ChangeDetectorRef } from "@angular/core";

import { routerTransition } from "app/shared/animations/router-transition.animation";
import { EspecializacaoService } from "../../service/especializacao.service";
import { DetalheCursoComponent } from "../detalhe-curso.component";
import { environment } from "environments/environment";

@Component({
  selector: "cm-sobre-o-programa",
  templateUrl: "./sobre-o-programa.component.html",
  styleUrls: ["./sobre-o-programa.component.scss"],
  animations: [routerTransition],
})
export class SobreOProgramaComponent implements OnInit {
  enviroment: string
  @HostBinding("@routerTransition") routerTransition = true;
  @HostBinding("style.display") display = "block";

  detalhesCurso: any[] = [];

  constructor(
    private conteudoEspecializacao: EspecializacaoService,
    private idCurso: DetalheCursoComponent,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.enviroment = environment.loginContexto
    console.log(this.enviroment)
    const idCurso = this.idCurso.cursoIdentificador;
    this.conteudoEspecializacao
      .listCursoEspecializacaoId(idCurso)
      .subscribe((detalhes) => {
        this.detalhesCurso = Array.isArray(detalhes) ? detalhes : [detalhes];
        console.log(this.detalhesCurso)
        this.cdr.detectChanges();
      });
  }
}
